// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R4Z9","textarea":"styles_textarea__2YaP2"};